import { render, staticRenderFns } from "./traceHistogram.vue?vue&type=template&id=75d007f4&scoped=true"
import script from "./traceHistogram.vue?vue&type=script&lang=js"
export * from "./traceHistogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d007f4",
  null
  
)

export default component.exports